import cookies from 'js-cookie';

import { CLIENT_WORKSPACE_TOKEN_COOKIE, PAGE_NAMES } from '~/shared/constants';

export const clearRumState = () => {
  try {
    cookies.remove('cwr_s', { path: '/', domain: 'prana-club.com' });
    cookies.remove('cwr_u', { path: '/', domain: 'prana-club.com' });

    cookies.remove('cwr_s');
    cookies.remove('cwr_u');

    localStorage?.removeItem('cwr_c');
    localStorage?.removeItem('cwr_i');

    if (typeof window !== 'undefined') {
      delete (window as any).__pranaClubRum;
    }
  } catch (e) {
    console.error('Failed to clear RUM state', e);
  }
};

const BASIC_MODULE_STRUCTURE_STORAGE_PREFIX = 'isBasicModuleStructure';

export const clearBasicModuleStructureState = () => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    Object.keys(window.localStorage).forEach((key) => {
      if (key.startsWith(BASIC_MODULE_STRUCTURE_STORAGE_PREFIX)) {
        window.localStorage.removeItem(key);
      }
    });
  } catch (e) {
    console.error('Failed to clear basic module structure state', e);
  }
};

export const clearUserCourseInfo = () => {
  localStorage?.removeItem('courseCategory');
  localStorage?.removeItem('lessonTemplate');
  localStorage?.removeItem('selectedCourse');
  localStorage?.removeItem('selectedTab');
  localStorage?.removeItem('filesManagerIsDateSortDesc');
  localStorage?.removeItem('filesManagerIsNameSortDesc');
  localStorage?.removeItem('locale');
  localStorage?.removeItem('isUserInfoMaximized');
  localStorage?.removeItem('isSubscribed');
  clearBasicModuleStructureState();
};

export const getSignOutUserQuery = () => {
  cookies.remove('id_token');
  clearUserCourseInfo();
  clearRumState();
};

export const getSignOutReferralUserQuery = () => {
  cookies.remove(CLIENT_WORKSPACE_TOKEN_COOKIE);
  clearRumState();
};

export const signOutAndRedirectToSignIn = (isClientsPanel) => {
  isClientsPanel ? getSignOutReferralUserQuery() : getSignOutUserQuery();
  window.location.href = isClientsPanel ? PAGE_NAMES.CLIENTS_SIGN_IN : PAGE_NAMES.SIGN_IN;
};
